import React from 'react';
import Expmanage from '../../../../components/Expmanage';

function Expertise() {
  return <Expmanage />;
}

export default Expertise;
